/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryEngineType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryEngineType");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryEngineType.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryEngineType>): AutomationTemplateQueryEngineType {
        let obj = Object.assign(new AutomationTemplateQueryEngineType(), model);
        AutomationTemplateQueryEngineType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryEngineType>): AutomationTemplateQueryEngineType {
        if (!model) return null;
        return AutomationTemplateQueryEngineType.newInstance(<AutomationTemplateQueryEngineType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryEngineType) {
        if (!obj) return;

        models.AutomationTemplateQueryEngineType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryEngineType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryEngineType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * DSL type of the template
     */
    engine_types: Array<models.TemplateEngineType>;

}
